import {gql} from 'apollo-boost'

export const GET_REPORT_DAILY_REPORT = gql`
  query getReportDaily($payload: ReportDailyFiltersInput) {
    getReportDaily(
      payload: $payload
    ){
      reportDate
      contractNo
      contractName
      curriculum
      loanType
      educationStatus
      contractStatus
      agingDate
      agingNumber
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPenaltyRemain
      accruedInterestRemain
    }
  }
`

export const GET_REPORT_GENERAL = gql`
  query getReportGeneral($payload: ReportGeneralFiltersInput) {
    getReportGeneral(
      payload: $payload
    ){
      reportDate
      contractNo
      contractName
      curriculum
      loanType
      educationStatus
      contractStatus
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedPenaltyRemain
      accruedInterestRemain
    }
  }
`

export const GET_REPORT_AGING = gql`
  query getReportAging($payload: ReportAgingFiltersInput) {
    getReportAging(
      payload: $payload
    ){
      reportDate
      contractNo
      contractName
      curriculum
      loanType
      educationStatus
      contractStatus
      closeDate
      assessmentDate
      agingDate
      agingNumber
      paymentRoundAmount
      outstandingBalanceRemain
      principleRemain
      accruedInterestRemain
    }
  }
`

export const GET_REPORT_SUMMARY = gql`
  query getReportSummary($payload: ReportSummaryFiltersInput) {
    getReportSummary(
      payload: $payload
    ){
      idCardNumber
      contractNo
      contractName
      curriculum
      loanType
      educationStatus
      forecastDate
      contractStatus
      closeDate
      assessmentDate
      loanAmount
      balance
      paymentAmount
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      balanceRemain
      totalPaymentAmount
      totalPaidAccruedFee
      totalPaidAccruedPenalty
      totalPaidAccruedInterest
      totalPaidPrinciple
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      principleRemain
      agingDate
      agingNumber
    }
  }
`

export const GET_REPORT_SUMMARY_EIR = gql`
  query getReportSummaryEir($payload: ReportSummaryFiltersInput) {
    getReportSummaryEir(
      payload: $payload
    ){
      contractNo
      contractName
      curriculum
      loanType
      educationStatus
      contractStatus
      closeDate
      assessmentDate
      agingDate
      agingNumber
      loanAmount
      interestRateEir
      paymentAmount
      paidAccruedFee
      paidAccruedPenalty
      paidAccruedInterest
      paidPrinciple
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      principleRemain
      balanceRemain
      balanceRemainCurr
      paymentAmountCurr
      paidAccruedFeeCurr
      paidAccruedPenaltyCurr
      paidAccruedInterestCurr
      paidPrincipleCurr
    }
  }
`

export const GET_REPORT_SUMMARY_FORECAST = gql`
  query getReportSummaryForecast($payload: ReportSummaryFiltersInput) {
    getReportSummaryForecast(
      payload: $payload
    ){
      contractNo
      contractName
      curriculum
      loanType
      educationStatus
      contractStatus
      loanAmount
      principle
      interestRate
      paymentAmount
      paidInterest
      paidPrinciple
      principleRemain
      agingDate
      agingNumber
    }
  }
`

export const GET_REPORT_SUMMARY_REMITTANCE = gql`
  query getReportSummaryRemittance($payload: ReportSummaryFiltersInput) {
    getReportSummaryRemittance(
      payload: $payload
    ){
      studentCode
      accoNo
      contractNo
      contractName
      contractStatus
      project
      facultyCurriculum
      loanType
      tuitionFeeDate
      tuitionFeeAmount
      costOfLivingDate
      costOfLivingAmount
      remark
      agingDate
      agingNumber
      outstandingBalanceRemain
      accruedFeeRemain
      accruedPenaltyRemain
    }
  }
`

export const GET_REPORT_PAYIN = gql`
  query getReportPayin($payload: ReportPayinFiltersInput) {
    getReportPayin(
      payload: $payload
    ){
      contractNo
      contractName
      paymentRoundDate
      amount
      project
      curriculum
      loanType
      paymentRoundType
      address
      addressDoc{
        locationDoc
        houseNumberDoc
        mooDoc
        alleyDoc
        roadDoc
        subDistrictDoc
        districtDoc
        provinceDoc
        zipcodeDoc
      }
      remark
    }
  }
`

export const GET_REPORT_RECEIPT = gql`
  query getReportReceipt($payload: ReportReceiptFiltersInput) {
    getReportReceipt(
      payload: $payload
    ){
      id
      receiptNo
      referenceNo
      receiptDate
      contractNo
      contractName
      contractAmount
      studentCode
      curriculum
      interestRate
      balance
      paidAmount
      paidFee
      paidPenalty
      paidInterest
      paidPrinciple
      principleRemain
      balanceRemain
      outstandingBalanceRemain
      accruedFeeRemain
      accruedPenaltyRemain
      accruedInterestRemain
      adjustment
      agingDate
      agingNumber
      address
      addressDoc{
        locationDoc
        houseNumberDoc
        mooDoc
        alleyDoc
        roadDoc
        subDistrictDoc
        districtDoc
        provinceDoc
        zipcodeDoc
      }
    }
  }
`

export const GET_REPORT_LOANINFO = gql`
  query getReportLoanInfo($payload: ReportExecutiveFiltersInput) {
    getReportLoanInfo(
      payload: $payload
    ){
      loanTypeNo
      loanTypeName
      contractSummary
      contractAmount
      loanAmount
      billCount
      billAmount
      paymentCount
      paymentAmount
      paymentOver
      balanceCount
      balanceAmount
    }
  }
`

export const GET_REPORT_LOANTRACKING = gql`
  query getReportLoanTracking($payload: ReportExecutiveFiltersInput) {
    getReportLoanTracking(
      payload: $payload
    ){
      no
      hierarchy
      summary
      amount
    }
  }
`

export const GET_REPORT_LOAN_CLASSIFY = gql`
  query getReportLoanClassify($payload: ReportExecutiveFiltersInput) {
    getReportLoanClassify(
      payload: $payload
    ){
      no
      studentCode
      contractNo
      contractName
      faculty
      loanTypeName
      agingNumber
      billAmount
      paymentAmount
      paymentOver
      balanceAmount
      accruedFeeRemain
      accruedPenaltyRemain
      balanceRemain
      mobile
      fullNameSuretySt
      mobileSuretySt
      fullNameSuretyNd
      mobileSuretyNd
      fullNameSuretyRd
      mobileSuretyRd
      fullNameSuretyTh
      mobileSuretyTh
      callHistoriesSt
      callHistoriesNd
      callHistoriesRd
      lawsuit
    }
  }
`
